export default "__VITE_ASSET__66eb8db0__"